import { io, type Socket } from 'socket.io-client'
import { useAuthStore } from '../../stores/auth'
import { attachPresenceHold } from './presenceHold'

/**
 * Socket.IO client with the account JWT on the handshake.
 */
export function createAppSocket(): Socket {
  const opts = {
    autoConnect: true,
    auth: (cb: (data: { token: string }) => void) => {
      cb({ token: useAuthStore().token })
    },
    // A failed long-poll ("xhr poll error") still tries the websocket before
    // the attempt is abandoned. Do not pair this with rememberUpgrade: that
    // path drops polling from the list when the websocket attempt fails.
    tryAllTransports: true,
  }
  const serverUrl = import.meta.env.VITE_SERVER_URL
  const socket = serverUrl
    ? io(serverUrl, opts)
    : io({ path: '/socket.io', ...opts })
  attachPresenceHold(socket)
  return socket
}
